import { PreIPOUpdateSharePriceFormValues } from './types';

export const defaultPreIPOUpdateSharePriceFormValues: PreIPOUpdateSharePriceFormValues =
  {
    newDate: null,
    chargesAndFees: [
      {
        lowerLimit: '',
        upperLimit: '',
        sharePrice: '',
        tax: '',
        documentationChargesPercent: '',
        documentationChargesAmount: '',
        platformChargesPercent: '',
        platformChargesAmount: '',
        stampDuty: '',
        dpCharges: ''
      }
    ],
    newChargesAndFeesDate: null,
    newChargesAndFeesVisibility: false,
    showPrefillNotice: false,
    newCommitmentAmount: ''
  };

export const defaultStampDutyValue = '0.015';
export const defaultDpChargesValue = '0.05';
